//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import md5 from 'js-md5'
import {axiosGet, login, getPlatformRoleDic} from "../../api";

export default {
  layout: 'other',
  name: 'login',
  data() {
    return {
      transition: true,
      remember: false,
      isFind: false,
      form: {
        username: '',
        passwd: '',
        platformId:null
      },
      form2: {
        username: "",
        verifyCode: "",
        newPasswd: "",
        confirmPasswd: ""
      },
      // 表单验证，需要在 el-form-item 元素中增加 prop 属性
      rules: {
        username: [
          {required: true, message: '账号不可为空', trigger: 'blur'}
        ],
        passwd: [
          {required: true, message: '密码不可为空', trigger: 'blur'}
        ],
        platformId: [
          {required: true, message: '请选择平台', trigger: 'change'}
        ]
      },
      rules2: {},
      // 对话框显示和隐藏
      dialogVisible: false,
      platformVisible:false,
      platformList: []
    }
  },
  methods: {

    usernameFocus(byId){
      var username = document.getElementById(byId);
      if(username){
        username.style.border = '2px solid #00B8FF';
      }
    },
    usernameBlur(byId){
      var username = document.getElementById(byId);
      if(username){
        username.style.removeProperty("border");
      }
    },
    login() {
      setTimeout(()=>{
        //若手速都快有可能跳过检索
        if(this.platformList.length > 1){
          if(!this.form.platformId){
            this.$message.info("请选择平台！");
            this.$refs["option"].focus();
            return
          }
        }
        // 为表单绑定验证功能
        this.$refs.form.validate((valid) => {
          if (valid) {
            const params = {
              username: this.form.username,
              passwd: md5(this.form.passwd),
            };
            login(params).then(resp => {
              if (resp.data.result.success === true) {
                const date = new Date();
                date.setFullYear(date.getFullYear() + 1);
                this.$cookies.set('remember', this.remember, {expires: date});
                if (this.remember) {
                  this.$cookies.set('username', this.form.username, {expires: date});
                } else {
                  this.$cookies.remove('username');
                }
                this.$cookies.set('token', resp.data.token);
                this.$cookies.set("systemId", resp.data.system.ide);
                this.$cookies.set('user', resp.data.user);
                this.$store.dispatch('loginInfo/synchronize');
                this.$store.dispatch('loginInfo/initSystemMember');
                this.$cookies.set('system', resp.data.system);
                //判断是否异常退出
                if(this.$store.state.diagnosis.diagnosisResultId){
                  this.$store.commit('diagnosis/setDiagnosisResultId',null);
                }
                // this.$router.push('/appoint');
                this.$router.push({path:'/diagnosis/main',query: {date: Date.now()}});
                // this.$router.push('/appointment');
                this.currentUserSelectRole();
              } else {
                this.$message({message: '账号或密码错误', type: 'error'})
              }
            });
          }
        })
      },200)
    },
    find() {

    },
    getPlatformRole() {
      if (this.form.username == ''){
        this.platformList = [];
        this.form.platformId = '';
        return;
      }
      this.platformList  =[];
      getPlatformRoleDic({username: this.form.username}).then(resp => {
        if (resp.data.result.success === true) {
          this.platformList = resp.data.list;
          this.form.platformId = null;
          if(this.platformList != null && this.platformList.length > 1){
            this.platformVisible =true;
          }else{
            this.platformVisible =false;
          }
        }
      });
    },
    currentUserSelectRole() {
      if (this.platformList.length > 1) {
        const platform = this.platformList.find(item => item.id == this.form.platformId);
        const roleId = platform.roles[0].id;
        // axiosGet("/user/currentUserSelectPlatform", {platformId}).then(resp =>{
        axiosGet("/cmmSysUserRole/currentUserSelectRole", {roleId}).then(resp => {
          this.$store.dispatch('loginInfo/synchronize');
          // this.$store.commit('platformSelectDialog/set', false);
        })
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.transition = false;
    }, 2000);
    if (this.$cookies.get('remember')) {
      this.remember = this.$cookies.get('remember');
      this.form.username = this.$cookies.get('username');
      if (this.form.username) this.getPlatformRole()
    }
  }
}
